// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Layout from '@/views/todoCenter/default/workflow/layout/index'
import wechatLayout from '@/views/todoCenter/default/wechat/layout/index'

//多处用到的组件
import defaultIcon from '@/components/todoCenter/defaultIcon'
import collect from '@/components/todoCenter/collect'
import bannerImg from '@/components/todoCenter/bannerImg'
import stepsmini from '@/components/todoCenter/stepsmini'
import Logo from '@/components/todoCenter/logo'
import ProcessPass from '@/components/todoCenter/process'
import PjModal from '@/components/todoCenter/pjmodal'
import DetailModal from '@/components/todoCenter/detailmodal'
import OtherIcon from '@/components/todoCenter/icons'

// import './aiDialog/css/aiDialog.css'
import VueApollo from 'vue-apollo'
import apolloProvider from './apolloConfig'
Vue.use(VueApollo);

import axios from './axiosConfig'
//人工智能
// import aiDialog from './aiDialog/js/aiDialog.js'
Vue.prototype.$axios=axios;

Vue.config.productionTip = false

Vue.component('pc',Layout);
Vue.component('mobile',wechatLayout);

//定义一些全局组件
Vue.component('defaultIcon',defaultIcon);
Vue.component('collect',collect);
Vue.component('bannerImg',bannerImg);
Vue.component('stepsmini',stepsmini);
Vue.component('Logo',Logo);
Vue.component('ProcessPass',ProcessPass);
Vue.component('PjModal',PjModal);
Vue.component('DetailModal',DetailModal);
Vue.component('OtherIcon',OtherIcon);

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

import ant from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
Vue.use(ant);

/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  data:function(){
    return {
      userName:"8980u0hp0",
      account:"",
    }
  },
  router,
  store,
  provide: apolloProvider.provide(),
  components: { 'pc':Layout ,'mobile':wechatLayout},
  render: h=>h(App)
  // template: '<mobile/>'
})
export default vue


// WEBPACK FOOTER //
// ./src/main.js